<script>
	export let columns = 4;
	export let gap     = 0;
	export let gapx    = gap[0] || gap;
	export let gapy    = gap[1] || gap;
</script>

<div
	class="grid"
	style="
		--columns-small  : {columns[0] || columns};
		--columns-medium : {columns[1] || columns[0] || columns};
		--columns-large  : {columns[2] || columns[1] || columns[0] || columns};
		--gap-x          : {gapx}px;
		--gap-y          : {gapy}px;
	"
>
	<slot />
</div>

<style lang="scss">
	@import '../scss/mixins.scss';

	.grid {
		display: grid;
		column-gap: var(--gap-x);
		row-gap: var(--gap-y);

		@include small-only {
			grid-template-columns: repeat(var(--columns-small), 1fr);
		}

		@include tablet-portrait {
			grid-template-columns: repeat(var(--columns-medium), 1fr);
		}

		@include desktop {
			grid-template-columns: repeat(var(--columns-large), 1fr);
		}
	}
</style>
